/* istanbul ignore file */
import { makeFragmentData } from '@packages/gql/generated/shopping';
import type {
  AddToBasketTrackingFragmentFragment,
  BreadcrumbBasketDataQuery,
} from '@packages/gql/generated/shopping/graphql';
import { AddToBasketTrackingFragmentFragmentDoc } from '@packages/gql/generated/shopping/graphql';
import {
  getGlycerinServicesCurrencyDataMock,
  getGlycerinServicesDataMock,
} from '../../helper/getGlycerinServices/mockdata';
import { getGlycerinAvailabilityDataMock } from '../../helper/getGlycerinAvailability/mockdata';
import { getGlycerinArticleIdDataMock } from '../../helper/getGlycerinArticleId/mockdata';

export const useAddToBasketTrackingDataMock: AddToBasketTrackingFragmentFragment = {
  ' $fragmentRefs': {
    GetGlycerinArticleIdFragmentFragment: getGlycerinArticleIdDataMock,
  },
  akl: 'AKLBB628362489',
  addToBasketTrackingAplus: getGlycerinServicesDataMock,
  availability: {
    ...getGlycerinAvailabilityDataMock,
    message: 'vorrätig - in 2-3 Werktagen bei dir',
  },
  brand: {
    name: 'Markenname',
  },
  defaultCategory: '10041',
  dimensions: [
    {
      axisType: 'COLOR',
      type: 'SELECT',
      values: [
        { rgb: '000', displayText: 'black', sku: '1' } as any,
        { rgb: 'fff', displayText: 'white', sku: '2' } as any,
        { variationMainImage: '/image', displayText: 'invalid' } as any,
      ],
    },
  ],
  longDescription: 'Tolles Produkt mit ganz viel Beschreibungstext.',
  marketcode: 220,
  media: [
    {
      url: 'https://bilder.baur.de/i/empiriecom/178bbb3e07613a99de2a7ec2c059149d.jpg',
    },
  ],
  name: 'Tolles Produkt',
  price: {
    ...getGlycerinServicesCurrencyDataMock,
    currency: 'EUR',
    valueOld: null,
    value: 51472,
    saving: {
      value: 21428,
    },
  },
  orderNumber: '7353915',
  promotion: '009',
  sku: '7353915077-0-1678589701',
};

export function getUseAddToBasketTrackingFragmentedData(
  data?: AddToBasketTrackingFragmentFragment,
) {
  return makeFragmentData(
    data || useAddToBasketTrackingDataMock,
    AddToBasketTrackingFragmentFragmentDoc,
  );
}

export const useAddToBasketTrackingBreadcrumbBasketDataMock: BreadcrumbBasketDataQuery = {
  breadcrumb: {
    breadCrumb: [{ name: 'jedimeistex' }, { name: 'lightsabers' }],
  },
};
